import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const calendarControls = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing(0, 1)};
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);

  button:focus,
  button:hover {
    outline: none;

    svg {
      color: ${theme.colors.neutral80};
      transition: color ease-in 300ms;
    }
  }
`;

export const controlsHeader = css`
  height: 56px;
  border-bottom: 1px solid ${theme.colors.neutral20};
  display: flex;
  margin: ${theme.spacing(0, -2, 2)};
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const titleHeader = css`
  display: flex;
  align-items: center;
  padding: ${theme.spacing(0, 2, 0, 2.5)};
  border-radius: ${theme.borderRadius.small};
  outline: none;
  position: relative;
  height: 40px;

  &::after {
    content: '';
    width: calc(100% + ${theme.spacing(1.5)});
    height: calc(100% + ${theme.spacing(1.5)});
    display: block;
    border: 2px solid ${theme.colors.primary50};
    border-radius: ${theme.borderRadius.small};
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: opacity 150ms ease-out;
  }

  span {
    height: 18px;
    display: flex;
    margin-left: 10px;
    flex-direction: column;
  }

  &:hover {
    background-color: ${theme.colors.neutral5};
    transition: background-color 0.2s ease;

    svg {
      color: ${theme.colors.neutral80};
      transition: color ease-in 300ms;
    }
  }

  &:focus-visible {
    background: ${theme.colors.neutral5};
    transition: fill 250ms ease-in-out;
    svg {
      fill: ${theme.colors.neutral80};
    }
    &::after {
      opacity: 1;
    }
  }
  &:not(:focus-visible) {
    &::after {
      opacity: 0;
    }
  }
`;

export const monthName = css`
  color: ${theme.colors.neutral90};
  font-size: ${theme.fontSize(16)};
  font-weight: ${theme.font.weight.bold};
  margin: 0;
`;

export const CalendarControlsStyles = {
  calendarControls: calendarControls,
  controlsHeader: controlsHeader,
  monthName: monthName,
  titleHeader: titleHeader,
};
